

















































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'

import {
  CreateItemModal,
  CreateOptionGroupModal,
  ItemImageContainer,
  NetworkErrorEmptyState,
  RenameModal,
  SwitchListItem,
  UpdateImageModal,
  VsLoading
} from '@/components'

import { ListItem, MobileLayout, SkeletonBox } from '@/layouts/components'

import {
  AsyncState,
  ItemGroup,
  DropDownButton,
  ItemGroupResourcePayload,
  ModalState
} from '@/models'

import { ItemGroupItems, ItemGroupOptionGroups } from '@/store/menu/state'
import { RelationMap } from '@/store/models'
import { RootState } from '@/store/state'

@Component({
  components: {
    CreateItemModal,
    CreateOptionGroupModal,
    ItemImageContainer,
    ListItem,
    MobileLayout,
    NetworkErrorEmptyState,
    RenameModal,
    SkeletonBox,
    SwitchListItem,
    UpdateImageModal,
    VsLoading
  }
})
export default class ItemGroupDetails extends Vue {
  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  loadState = new AsyncState()
  loadItemsState = new AsyncState()
  loadOptionGroupsState = new AsyncState()
  changeIsActiveState = new AsyncState()
  createItemState = new ModalState()
  createOptionGroupState = new ModalState()
  renameState = new ModalState()
  removeState = new ModalState()
  updateImageState = new ModalState()

  isActive = false
  skipOnIsActiveChange = false

  get buttons (): DropDownButton[] {
    if (this.itemGroup === null) {
      return []
    }

    return [
      {
        icon: 'more_vert',
        color: 'dark',
        items: [
          {
            text: 'Renomear',
            handler: () => { this.renameState.isActive = true }
          },
          {
            text: 'Remover',
            handler: () => {
              this.removeState.isActive = true
            }
          }
        ]
      }
    ]
  }

  get isWaiting () {
    return (
      this.changeIsActiveState.isPending ||
      this.renameState.isPending ||
      this.removeState.isPending ||
      this.updateImageState.isPending
    )
  }

  get itemGroup (): ItemGroup | null {
    return this.itemGroupById(this.itemGroupId)
  }

  get itemGroupItems (): ItemGroupItems | undefined {
    return this.itemGroupsItems[this.itemGroupId]
  }

  get itemGroupOptionGroups (): ItemGroupOptionGroups | undefined {
    return this.itemGroupsOptionGroups[this.itemGroupId]
  }

  get itemsTotal () {
    return this.itemGroupItems
      ? this.itemGroupItems.total
      : 0
  }

  get optionGroupsTotal () {
    return this.itemGroupOptionGroups
      ? this.itemGroupOptionGroups.total
      : 0
  }

  get title () {
    if (this.itemGroup !== null) {
      return this.itemGroup.title
    }

    return this.loadState.isPending
      ? null
      : 'Categoria'
  }

  @State((state: RootState) => state.menu.itemGroups.items)
  readonly itemGroupsItems!: RelationMap<ItemGroupItems>

  @State((state: RootState) => state.menu.itemGroups.optionGroups)
  readonly itemGroupsOptionGroups!: RelationMap<ItemGroupOptionGroups>

  @Getter('menu/itemGroupById')
  readonly itemGroupById!: (id: number) => ItemGroup | null

  @Action('menu/loadItemGroup')
  loadItemGroup!: (id: number) => Promise<void>

  @Action('menu/loadItemPage')
  loadItemPage!: (itemGroupId: number) => Promise<void>

  @Action('menu/loadOptionGroupPage')
  loadOptionGroupPage!: (itemGroupId: number) => Promise<void>

  @Action('menu/updateItemGroup')
  updateItemGroup!: (data: { id: number; payload: ItemGroupResourcePayload }) => Promise<void>

  @Action('menu/updateItemGroupImage')
  updateImage!: (data: { id: number; imageFile: File }) => Promise<void>

  @Action('menu/removeItemGroup')
  removeItemGroup!: (id: number) => Promise<void>

  @Watch('isActive')
  async onIsActiveChange (val: boolean, old: boolean) {
    if (this.itemGroup === null) {
      return
    }

    if (this.skipOnIsActiveChange) {
      this.skipOnIsActiveChange = false
      return
    }

    try {
      await this.changeIsActiveState.handle(
        this.handleUpdate({
          title: this.itemGroup.title,
          active: val
        })
      )
    } catch (e) {
      this.skipOnIsActiveChange = true
      this.isActive = old

      this.$vs.notify({
        title: 'Não foi possível alterar.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async created () {
    if (this.itemGroup === null) {
      await this.reload()
    } else {
      this.loadState.touch()
    }

    if (this.itemGroup && this.isActive !== this.itemGroup.isActive) {
      this.skipOnIsActiveChange = true
      this.isActive = this.itemGroup.isActive
    }

    if (this.itemsTotal === 0) {
      this.handleLoadItems()
    } else {
      this.loadItemsState.touch()
    }

    if (this.optionGroupsTotal === 0) {
      this.handleLoadOptionGroups()
    } else {
      this.loadOptionGroupsState.touch()
    }
  }

  async reload () {
    try {
      await this.loadState.handle(
        this.loadItemGroup(this.itemGroupId)
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleLoadItems () {
    try {
      await this.loadItemsState.handle(
        this.loadItemPage(this.itemGroupId)
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleLoadOptionGroups () {
    try {
      await this.loadOptionGroupsState.handle(
        this.loadOptionGroupPage(this.itemGroupId)
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleRemove () {
    try {
      await this.removeState.handle(
        this.removeItemGroup(this.itemGroupId)
      )

      this.$router.back()
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível remover.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleRename (title: string) {
    if (this.itemGroup === null) {
      return
    }

    try {
      await this.renameState.handle(
        this.handleUpdate({
          title,
          active: this.itemGroup.isActive
        })
      )
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível renomear.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  handleUpdate (payload: ItemGroupResourcePayload) {
    return this.updateItemGroup({
      id: this.itemGroupId,
      payload
    })
  }

  async handleUpdateImage (imageFile: File) {
    try {
      await this.updateImageState.handle(
        this.updateImage({
          id: this.itemGroupId,
          imageFile
        })
      )
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível alterar a foto.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }
}
